import React, { ReactElement } from 'react';
import { Form, Select } from 'antd';

import { ContentItemBase } from 'pricing/types';
import { pricingContent } from 'pricing/utilities/localStorage/pricingContentStorage';
import { testId } from 'pricing/utilities/test/dataTestId';

interface Props {
  disabled: boolean;
}

function FilterFieldContractTermTypes(props: Props): ReactElement {
  const { disabled } = props;

  return (
    <Form.Item
      name="breeder_contract_term_type_id"
      style={{ width: 200, marginBottom: 0 }}
    >
      <Select
        data-testid={testId.filterFieldContractTermTypes}
        allowClear
        disabled={disabled}
        placeholder="Term Type"
      >
        {pricingContent?.contractTermTypes?.map((termType: ContentItemBase) => (
          <Select.Option
            data-testid={testId.filterFieldContractTermTypeOption}
            key={termType.id}
            value={termType.id}
          >
            {termType.name}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
}

export default FilterFieldContractTermTypes;
